import { disputeSource } from "@redotech/redo-dispute-db-schema/dispute-definition";
import * as z from "zod";

export const toggleDisputeAutoEvidence = {
  name: "toggleDisputeAutoEvidence" as const,
  input: z.object({
    disputeId: z.coerce.bigint(),
    source: z.enum(disputeSource),
    disabled: z.boolean(),
  }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
